var map = {
	"./h1.png": "fd91",
	"./h2.png": "8ff1",
	"./h3.png": "2a5f",
	"./h4.png": "8d32",
	"./h5.png": "2dc3",
	"./h6.png": "9147",
	"./h7.png": "7f75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cad";